import { type MouseEvent } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';
import { truncateMiddle } from '@liminal/utils/truncate';
import { FONT_STACK_BODY } from '@liminal/brand/font-faces';

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// A ledger account id is either a UUID (a user, or an internal account that is
// not a user) or a system account name ("fees", "reserves"). Every one of them
// has ledger activity, so every one of them links to /accounts/<id> — unlike
// UserIdLink, which can only safely send real user ids to /users/<id>.
interface AccountIdLinkProps {
  accountId: string | null | undefined;
  full?: boolean;
  fontSize?: number | string;
}

export function AccountIdLink({ accountId, full = false, fontSize = 12 }: AccountIdLinkProps) {
  if (!accountId) return <>{'—'}</>;
  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
  };
  // System account names ("fees") are short and meaningful; truncation is only
  // for UUIDs.
  const label = full || !UUID_PATTERN.test(accountId) ? accountId : truncateMiddle(accountId);
  return (
    <MuiLink
      component={RouterLink}
      to={`/accounts/${encodeURIComponent(accountId)}`}
      onClick={handleClick}
      underline="hover"
      sx={{ fontFamily: FONT_STACK_BODY, fontSize }}
    >
      {label}
    </MuiLink>
  );
}
